import * as React from 'react';
import { SVGProps } from 'react';

const IconRUOSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.205 1a1 1 0 0 0-1 1v1.143a1 1 0 0 0 1 1h.565v6.286l-2.375 3.815 10.226-1.26-1.59-2.555V4.143h.564a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-7.39z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.536 14.454 5.328 15.959l-3.241 5.207A1.2 1.2 0 0 0 3.105 23h17.59a1.2 1.2 0 0 0 1.019-1.834l-4.178-6.712zM9 20a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm3.5-1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm3.5 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm1-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
    />
  </svg>
);
export default IconRUOSizeM;
